import { BACKEND_URI } from "../entries"
import { secureAPICall } from "../utils/sessionUtils"


export const requestTicketsStatsOverview = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/fetch-tickets-stats-overview", verbose: verbose })
}


export const requestTicketsChronologicalCount = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/fetch-tickets-chronological", verbose: verbose })
}


export const requestUserStatsOverview = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/get-user-stats-overview", verbose: verbose })
}


export const requestTicketsFirstReplyTimeChronological = ({ verbose = false }) => {
    return secureAPICall({ endpoint: BACKEND_URI + "/api/stats/fetch-tickets-first-reply-time-chronological", verbose: verbose })
}